import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import { Container, Spinner } from "react-bootstrap";
import ProfileCard from "../components/ProfileCard/ProfileCard";
import { pageTransition, pageVariants } from "../hooks/pagetransition";

const Team = () => {
  const [team, setTeam] = useState();
  useEffect(() => {
    fetch("/team-data.json")
      .then((res) => res.json())
      .then((data) => {
        setTeam(data);
      });
  }, []);
  return (
    <motion.div
      className="text-center pb-3"
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
      transition={pageTransition}
    >
      <h1>Our Story</h1>
      <Container
        className="px-5"
        style={{ margin: "auto", textAlign: "justify", padding: "5px", fontSize: '18px', fontWeight: '500' }}
      >
        We care about people and the planet. In the pursuit of a green world, we
        are leading through environmental education and offering sustainable
        solutions. <br /> <br />
        We have come a long way since the inception of the human race on earth.
        In the shadow of many problems, climate change is threatening our
        existence on the beautiful planet that we call home. We care about
        people and the planet. We have a common fight to protect and sustain
        ourselves. In the pursuit of a green world, we are leading through
        environmental education and offering sustainable solutions.
      </Container>
      <h1 className="mt-5">Team Members</h1>
      <div className="container">
        <div className="row">
          {team ? (
            team.map((el) => <ProfileCard key={el.id} el={el} />)
          ) : (
            <Spinner style={{ margin: "auto" }} animation="border" />
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default Team;
